@let isShown = isShown$ | async;
@let url = url$ | async;

@if (user$ | async; as userData) {
<div class="sidebar flex flex-col justify-between" [class.shown]="isShown">
  <div>
    <div id="brand-logo" class="brand-logo-wrapper">
      <img
        class="sidenav-logo sidenav-logo--collapsed"
        src="/assets/images/si-logomark-color-white.svg"
        alt="SalesIntel"
      />
      <img
        class="sidenav-logo sidenav-logo--expanded"
        src="/assets/images/si-logo-color-white.svg"
        alt="SalesIntel"
      />
    </div>

    <div class="sidebar-divider" aria-hidden="true"></div>

    <ul class="primary-navigation">
      <li>
        <a class="nav-item" [routerLink]="['results/dashboard']">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'house']"></fa-icon>
          </span>
        </a>
      </li>
      <li [appHoverMenu]="'.secondary-navigation'">
        <a class="nav-item" [class.active]="url | stringIncludes : [
          resultTabsetUrlsEnum.SEARCH,
          resultTabsetUrlsEnum.ICPINTEL,
          resultTabsetUrlsEnum.ROD,
          resultTabsetUrlsEnum.VISITORINTEL,
          resultTabsetUrlsEnum.INBOXINTEL,
          resultTabsetUrlsEnum.SAVEDSEARCHES,
          resultTabsetUrlsEnum.LISTS
        ]">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass']"></fa-icon>
          </span>
          @if (isShown) {
            <span class="nav-item-label">Discover Prospects</span>
          }
        </a>


        <ul class="secondary-navigation">
          <li><app-nav-item name="ProspectIntel (Search)" [restricted]="!(accountAttributesEnum.PROSPECT | hasAccessAsync | async)" [navRouterLink]="resultTabsetUrlsEnum.SEARCH">ProspectIntel (Search)</app-nav-item></li>
          <li *ngIf="(featureFlagsEnum.RepIntel | isFeatureFlagEnabled | async)"><app-nav-item name="RepIntel" [navRouterLink]="resultTabsetUrlsEnum.REPINTEL">RepIntel</app-nav-item></li>
          <li><app-nav-item name="ICPIntel" [restricted]="!(featureFlagsEnum.ICPIntel | isFeatureFlagEnabled | async)" [navRouterLink]="resultTabsetUrlsEnum.ICPINTEL">ICPIntel</app-nav-item></li>
          <li><app-nav-item name="Research on Demand" [restricted]="!(serviceCreditTypesEnum.ROD | hasServiceCredits | async)" [navRouterLink]="resultTabsetUrlsEnum.ROD">Research on Demand</app-nav-item></li>
          <li><app-nav-item name="VisitorIntel" [restricted]="!([addonsIdentifiersEnum.VISITORINTEL] | hasPlans | async)" [navRouterLink]="resultTabsetUrlsEnum.VISITORINTEL">VisitorIntel</app-nav-item></li>
          <li *ngIf="(accountAttributesEnum.INBOXINTEL | hasAccessAsync | async)"><app-nav-item name="InboxIntel" [navRouterLink]="resultTabsetUrlsEnum.INBOXINTEL">InboxIntel</app-nav-item></li>
          <li><app-nav-item name="Saved Searches" [restricted]="!(accountAttributesEnum.PROSPECT | hasAccessAsync | async)" [navRouterLink]="resultTabsetUrlsEnum.SAVEDSEARCHES">Saved Searches</app-nav-item></li>
          <li><app-nav-item name="Lists" [restricted]="!(accountAttributesEnum.PROSPECT | hasAccessAsync | async)" [navRouterLink]="resultTabsetUrlsEnum.LISTS">Lists</app-nav-item></li>
        </ul>
      </li>
      <li [appHoverMenu]="'.secondary-navigation'">
        <a class="nav-item">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'circle-play']"></fa-icon>
          </span>
          @if (isShown) {
            <span class="nav-item-label">Build AI Workflows</span>
          }
        </a>

        <ul class="secondary-navigation">
          <ng-template #legacyAgentsLisTpl>
            <li *ngIf="(featureFlagsEnum.IdealCustomerProfileAutomations | isFeatureFlagEnabled | async)"><app-nav-item name="Ideal Customer Profile Agents" tooltipIfTruncated="Ideal Customer Profile Agents" targetSelector=".nav-item-text" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.ICP_AUTOMATIONS] } }]" navQueryParamsHandling="merge">Ideal Customer Profile Agents</app-nav-item></li>
            <li><app-nav-item name="Intent Agents" [restricted]="!(featureFlagsEnum.IntentAutomations | isFeatureFlagEnabled | async)" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.INTENT_SETTINGS] } }]" [navQueryParams]="intentAgentsQueryParams" navQueryParamsHandling="merge">Intent Agents</app-nav-item></li>
            <li>
              <app-nav-item
                [restricted]="!userData.job_change_enabled"
                name="Job Change Agents"
                [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.JOB_CHANGE_AUTOMATIONS] } }]"
                navQueryParamsHandling="merge"
              >Job Change Agents</app-nav-item>
            </li>
            <li><app-nav-item name="News Agents" [restricted]="!(accountAttributesEnum.NEWSALERTS | hasAccessAsync | async)" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.AUTOMATION_SETTINGS] } }]" navQueryParamsHandling="merge">News Agents</app-nav-item></li>
            <li><app-nav-item name="VisitorIntel Agents" [restricted]="!(featureFlagsEnum.VisitorIntelAutomations | isFeatureFlagEnabled | async)" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.VISITOR_INTEL_AUTOMATIONS] } }]" navQueryParamsHandling="merge">VisitorIntel Agents</app-nav-item></li>
          </ng-template>

          <li *ngIf="(featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async)">
            <app-nav-item name="GTMCanvas" [navRouterLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS">GTMCanvas</app-nav-item>
          </li>

          <!-- V2: hide the Legacy Agents cluster (GTMCanvas + Intent Settings entries
               above/below stay visible in both V1 and V2). See GTM-CANVAS.md §11. -->
          @if (!(featureFlagsEnum.GtmCanvasV2 | isFeatureFlagEnabled | async)) {
            <li *ngIf="(featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async)" [appHoverMenu]="'.secondary-navigation'">
              <a class="nav-item">Legacy Agents</a>
              <ul class="secondary-navigation">
                <ng-container *ngTemplateOutlet="legacyAgentsLisTpl"></ng-container>
              </ul>
            </li>

            <ng-container *ngIf="!(featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async)">
              <ng-container *ngTemplateOutlet="legacyAgentsLisTpl"></ng-container>
            </ng-container>
          }
        </ul>
      </li>
      <li [appHoverMenu]="'.secondary-navigation'">
        <a class="nav-item">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'display-chart-up']"></fa-icon>
          </span>
          @if (isShown) {
            <span class="nav-item-label">Execute GTM</span>
          }
        </a>

        <ul class="secondary-navigation">
          <li>
            <app-nav-item
              name="AdsIntel"
              [restricted]="!userData.is_ads_intel_user && userData.ads_intel_enabled"
              [restrictedTooltipMessage]="'Ask your SalesIntel admin for access to AdsIntel.'"
              [disabled]="isAdsIntelDisabled$ | async"
              (clickedEvent)="onOpenAdsIntel()"
            >AdsIntel <mat-spinner *ngIf="isAdsIntelDisabled$ | async" [diameter]="24"></mat-spinner></app-nav-item>
          </li>
          <li *ngIf="userData.prospect_connect_enabled || (featureFlagsEnum.LaunchProspectConnect | isFeatureFlagEnabled | async)">
            <app-nav-item
              name="ProspectConnect"
              [restricted]="(userData.prospect_connect_enabled && !userData.is_prospect_connect_user) || (!userData.prospect_connect_enabled && (featureFlagsEnum.LaunchProspectConnect | isFeatureFlagEnabled | async))"
              [restrictedTooltipMessage]="(userData.prospect_connect_enabled && !userData.is_prospect_connect_user) ? 'Ask your SalesIntel admin for access to ProspectConnect' : null"
              [disabled]="isProspectConnectDisabled$ | async"
              (clickedEvent)="onOpenProspectConnect()"
            >ProspectConnect <mat-spinner *ngIf="isProspectConnectDisabled$ | async" [diameter]="24"></mat-spinner></app-nav-item>
          </li>
        </ul>
      </li>
      <li [appHoverMenu]="'.secondary-navigation'">
        <a class="nav-item" [class.active]="url | stringIncludes : [
          resultTabsetUrlsEnum.ENRICHMENT,
          resultTabsetUrlsEnum.FORMSINTEL,
          resultTabsetUrlsEnum.BOUNCEINTEL,
        ]">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'file-user']"></fa-icon>
          </span>
          @if (isShown) {
            <span class="nav-item-label">Enrich Data</span>
          }
        </a>

        <ul class="secondary-navigation">
          <li *ngIf="(accountAttributesEnum.HUBSPOT | hasAccessAsync | async) && (featureFlagsEnum.HsEnrichment | isFeatureFlagEnabled | async)">
            <app-nav-item
              name="HubSpot Enrichment"
              [restricted]="!userData.is_ops_admin"
              [navRouterLink]="resultTabsetUrlsEnum.ENRICHMENT"
              [restrictedTooltipMessage]="'Ask your SalesIntel admin for access to Enrichment.'"
              routerLinkActive="active"
            >HubSpot Enrichment</app-nav-item>
          </li>
          <li *ngIf="(featureFlagsEnum.ListEnrichment | isFeatureFlagEnabled | async)">
            <app-nav-item
              name="Custom Enrichment"
              [navRouterLink]="resultTabsetUrlsEnum.CUSTOM_ENRICHMENT"
              [restricted]="!(serviceCreditTypesEnum.ENRICHMENT | hasServiceCredits | async)"
              routerLinkActive="active"
            >Custom Enrichment</app-nav-item>
          </li>
          <li>
            <app-nav-item
              name="FormsIntel"
              [restricted]="!(accountAttributesEnum.FORMSINTEL | hasAccessAsync | async) || (!userData.is_admin && !userData.is_ops_admin)"
              [navRouterLink]="resultTabsetUrlsEnum.FORMSINTEL"
              [restrictedTooltipMessage]="(accountAttributesEnum.FORMSINTEL | hasAccessAsync | async) && !userData.is_admin && !userData.is_ops_admin ? 'Ask your SalesIntel admin for access to FormsIntel.' : null"
              routerLinkActive="active"
            >FormsIntel</app-nav-item>
          </li>
          <li *ngIf="(accountAttributesEnum.UNBOUNCE | hasAccessAsync | async)"><app-nav-item name="BounceIntel" [navRouterLink]="resultTabsetUrlsEnum.BOUNCEINTEL" routerLinkActive="active">BounceIntel</app-nav-item></li>
        </ul>
      </li>
      <li [appHoverMenu]="'.secondary-navigation'">
        <a class="nav-item">
          <span class="nav-item-icon">
            <fa-icon class="si-icon" [icon]="['fal', 'gear-complex']"></fa-icon>
          </span>
          @if (isShown) {
            <span class="nav-item-label">Settings</span>
          }
        </a>

        <ul class="secondary-navigation">
          <li *ngIf="userData.is_admin"><app-nav-item name="Account Management" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.ACCOUNT_SETTINGS] } }]" navQueryParamsHandling="merge">Account Management</app-nav-item></li>
          <li><app-nav-item name="Credit Balance" (clickedEvent)="onCreditsSettings()">Credit Balance</app-nav-item></li>

          <ng-container *ngIf="([
            accountAttributesEnum.HUBSPOT | hasAccessAsync | async,
            accountAttributesEnum.MARKETO | hasAccessAsync | async,
            accountAttributesEnum.DYNAMICS | hasAccessAsync | async,
            accountAttributesEnum.OUTREACH | hasAccessAsync | async,
            accountAttributesEnum.SALESFORCE | hasAccessAsync | async,
            accountAttributesEnum.SALESLOFT | hasAccessAsync | async,
            accountAttributesEnum.ZOHO | hasAccessAsync | async
          ] | filterBoolean : true).length > 1; else integrationsLisTpl">
            <li [appHoverMenu]="'.secondary-navigation'">
              <a class="nav-item">Integrations</a>

              <ul class="secondary-navigation">
                <ng-container *ngTemplateOutlet="integrationsLisTpl"></ng-container>
              </ul>
            </li>
          </ng-container>

          <li><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.FILE_CENTER] } }]" navQueryParamsHandling="merge">File Center</app-nav-item></li>
          <li><app-nav-item name="Buyer Persona Settings" (clickedEvent)="onBuyerPersonaSettings()">Buyer Persona Settings</app-nav-item></li>
          <li><app-nav-item (clickedEvent)="onCSVSettings()">CSV Settings</app-nav-item></li>
          <li><app-nav-item name="Intent Settings" [restricted]="!((featureFlagsEnum.GtmCanvasV2 | isFeatureFlagEnabled | async) || (featureFlagsEnum.IntentAutomations | isFeatureFlagEnabled | async))" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.INTENT_SETTINGS] } }]" navQueryParamsHandling="merge">Intent Settings</app-nav-item></li>
          <li><app-nav-item name="Technographic Settings" [restricted]="!(accountAttributesEnum.TECHNOGRAPHICS | hasAccessAsync | async)" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.TECHNOGRAPHICS] } }]" navQueryParamsHandling="merge">Technographic Settings</app-nav-item></li>
          <li><app-nav-item (clickedEvent)="onAboutSettings()">My System</app-nav-item></li>

          <ng-template #integrationsLisTpl>
            <li *ngIf="accountAttributesEnum.HUBSPOT | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.HUBSPOT] } }]" navQueryParamsHandling="merge">HubSpot Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.MARKETO | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.MARKETO] } }]" navQueryParamsHandling="merge">Marketo Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.DYNAMICS | hasAccessAsync | async"><app-nav-item tooltipIfTruncated="Microsoft Dynamics Settings" targetSelector=".nav-item-text" [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.DYNAMICS] } }]" navQueryParamsHandling="merge">Microsoft Dynamics Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.OUTREACH | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.OUTREACH] } }]" navQueryParamsHandling="merge">Outreach Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.SALESFORCE | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.SALESFORCE] } }]" navQueryParamsHandling="merge">Salesforce Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.SALESLOFT | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.SALESLOFT] } }]" navQueryParamsHandling="merge">Salesloft Settings</app-nav-item></li>
            <li *ngIf="accountAttributesEnum.ZOHO | hasAccessAsync | async"><app-nav-item [navRouterLink]="['', { outlets: { modal: [modalNavigationEnum.ZOHO] } }]" navQueryParamsHandling="merge">Zoho Settings</app-nav-item></li>
          </ng-template>
        </ul>
      </li>
    </ul>
  </div>
  <ul class="logout-navigation">
    <li>
      <a class="nav-item" (click)="onLogout()">
        <span class="nav-item-icon">
          <fa-icon class="si-icon" [icon]="['fal', 'right-from-bracket']"></fa-icon>
        </span>
      </a>
    </li>
  </ul>
</div>
}
